import { render, staticRenderFns } from "./WhatsappComparison.vue?vue&type=template&id=b097be12&scoped=true"
import script from "./WhatsappComparison.vue?vue&type=script&lang=js"
export * from "./WhatsappComparison.vue?vue&type=script&lang=js"
import style0 from "./WhatsappComparison.vue?vue&type=style&index=0&id=b097be12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b097be12",
  null
  
)

export default component.exports